import { computed } from 'vue';
import { klarna as klarnaConfig } from 'config';

export default function useKlarna(selectedPrice) {
  const price = computed(() => selectedPrice?.value?.lowestSalePriceTier?.values?.[0]?.value || 0);

  const klarnaPrice = computed(() => Math.floor(price.value * 100));
  const priceWithinRange = computed(() => price.value >= klarnaConfig.minProductPrice && price.value <= klarnaConfig.maxProductPrice);

  return {
    priceWithinRange,
    klarnaPrice,
  };
}
